import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Component that tracks page views when routes change
 * Place this inside your Router component in App.tsx
 */
const AnalyticsRouter: React.FC = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view when location changes
    const pageName = location.pathname;
    trackPageView(pageName);
    
    // Log for debugging
    console.log(`Page view tracked: ${pageName}`);
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default AnalyticsRouter; 